import { Update } from '@wix/materializer'
import { Component } from '@wix/thunderbolt-becky-types'
import type { Unref } from '@wix/thunderbolt-catharsis'
import type { RawModel } from '../../../../../types'

export type ConsumptionDataNode<TData, TDependencies, TRefConsumptionDependencies> = {
	getDependencies?: (data: TData) => TDependencies
	updateDependencies?: (data: {
		update: Update<void>
		inflatedComponent: Component
		dependencies: TDependencies
	}) => void
	toViewItem?: (data: {
		id: string
		value: Unref<TRefConsumptionDependencies>
		rawModel: RawModel
		aspect: string
	}) => any
}

export const createConsumptionDataNode = <TData, TDependencies, TRefConsumptionDependencies>(
	obj: ConsumptionDataNode<TData, TDependencies, TRefConsumptionDependencies>
) => obj
